// extracted by mini-css-extract-plugin
export default {"highlight":"iyna7LRlkqNZ5M1lAixI","table":"o_ThvhdWGSLOv5FxNrdm","tabs":"HfJds6xnHKOlCG7wV9VO","placeHolderShimmer":"K5tqlBiK8R76SuPXpfO0"};